export const getCssFromAttributes = (obj, parentObj) => {
  return Object.entries(obj).reduce((previousValue, item) => {
    const [property, value] = item;
    return `${previousValue} ${property}: ${value};`
  }, '');
};
